<template>
  <v-application v-if="access.employee_access_rights">
    <v-layout row class="ma-2">
      <v-flex md9>
        <v-crud-card
          name="role"
          to="/employees/access"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:remove="remove"
          v-bind:num-pages="num_pages"
          v-model="page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          EmployeesAccess
          v-bind:add_button_name="'add_role'"
        ></v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "EmployeesAccess",
  data: () => ({
    page: 1,
    num_pages: 0,
    headers: [
      { text: "Role", value: "name" },
      { text: "Access", value: "access" },
      { text: "Employees", value: "employees", align: "right" },
    ],
    data: [],
    data_loading: false,
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update() {
      this.data_loading = true;
      const roles = this.$communicator.then(
        this,
        await this.$communicator("accesses", {
          arguments: [10, this.page],
        })
      );
      if (roles) {
        this.data = roles.data;
        this.num_pages = roles.page;
      }
      this.data_loading = false;
    },
    async remove(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("delete_access", {
        params: {
          indexes: indices,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.update();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("role"), value: "name", available: true },
      { text: this.$t("access"), value: "access", available: true },
      {
        text: this.$t("employees"),
        value: "employees",
        align: "right",
        available: true,
      },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>